import UploadFileIcon from '@mui/icons-material/UploadFile';
import { IconButton, Link, Tooltip } from "@mui/material";
import React, { useState } from "react";
import { IMPORT_URL } from "../../Constants/Constants";
import AxiosInstance from "../../services/AxiosInstance";
import GenericCsvImportForm from "./GenericCsvImportForm";
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import ImportTableConfigDialog from "./ImportTableConfigDialog";


function GenericCsvImportDialog({
  tableId = "",
  tableName,
  variant = "button", // 'button' for add, 'link' for edit
  onSuccess,
}) {

  const [openTable, setOpenTable] = useState(false);
  const [editDataTable, setEditDataTable] = useState(null);

  const [open, setOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleTableClickOpen = async () => {
    if (tableId && tableId !== "") {
      setLoading(true);
      try {
        const response = await AxiosInstance.get(
          `${IMPORT_URL}/table/${tableId}`
        );
        setEditDataTable(response.data);
        setOpenTable(true);
      } catch (error) {
        console.error("Error fetching API data:", error);
      } finally {
        setLoading(false);
      }
    } else {
      setEditDataTable(null);
      setOpenTable(true);
    }
  };

  const handleTableClose = () => {
    setOpenTable(false);
    setEditDataTable(null);
  };

  const handleClickOpen = async () => {
    if (tableId && tableId !== "") {
      setLoading(true);
      try {
        const response = await AxiosInstance.get(
          IMPORT_URL + tableId
        );
        setEditData(response.data);
        setOpen(true);
      } catch (error) {
        console.error("Error fetching API data:", error);
      } finally {
        setLoading(false);
      }
    } else {
      setEditData(null);
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setEditData(null);
  };

  const renderTrigger = () => {
    if (variant === "link" && tableId) {
      return (
        <Link
          component="button"
          onClick={handleTableClickOpen}
          disabled={loading}
          sx={{
            cursor: "pointer",
            textDecoration: "none",
            color: "primary.main",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          {tableName}
        </Link>
      );
    }

    return (
      <div>
        <Tooltip
          title="Add Tables"
          onClick={handleTableClickOpen}
          disabled={loading}
        >
          <IconButton
            sx={{
              cursor: "pointer",
              margin: "2px",
              color: (theme) => theme.palette.grey[500],
              borderRadius: 2,
              border: 1,
              borderColor: "divider",
            }}
          >
            <PlaylistAddIcon color="primary" />
          </IconButton>
        </Tooltip>
        <Tooltip
          title="Data Import"
          onClick={handleClickOpen}
          disabled={loading}
        >
          <IconButton
            sx={{
              cursor: "pointer",
              margin: "2px",
              color: (theme) => theme.palette.grey[500],
              borderRadius: 2,
              border: 1,
              borderColor: "divider",
            }}
          >
            <UploadFileIcon color="primary" />
          </IconButton>
        </Tooltip>
      </div>
    );
  };

  return (
    <>
      {renderTrigger()}
      <ImportTableConfigDialog
        open={openTable}
        onClose={handleTableClose}
        editData={editDataTable}
        onSuccess={onSuccess}
        isEditMode={Boolean(editDataTable)}
      />
      <GenericCsvImportForm
        open={open}
        onClose={handleClose}
        editData={editData}
        onSuccess={onSuccess}
        isEditMode={Boolean(editData)}
      />
    </>
  );
}
export default GenericCsvImportDialog;
